import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["strong"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useMemo } from 'react';
import { StylesProvider, text, border } from '@rexlabs/styling';
import { merge } from 'lodash';
import { Banner } from './core';
var overrides = {
  banner: {
    strong: _objectSpread(_objectSpread({}, text.tokens({
      target: 'banner.neutral.strong',
      color: function color(_ref) {
        var token = _ref.token;
        return token('color.textStyle.body.contrast');
      }
    })), border.tokens({
      target: 'banner.neutral.strong',
      all: {
        color: 'primary.idle.default'
      }
    }))
  }
};
var strongButtonOverrides = {
  button: {
    outline: _objectSpread(_objectSpread(_objectSpread({}, text.tokens({
      target: 'banner.neutral.strong.button.outline',
      color: function color(_ref2) {
        var token = _ref2.token;
        return token('color.textStyle.body.contrast');
      }
    })), border.tokens({
      target: 'banner.neutral.strong.button.outline',
      all: {
        color: 'primary.idle.contrast'
      }
    })), {}, {
      hover: _objectSpread(_objectSpread({}, border.tokens({
        target: 'banner.neutral.strong.button.outline.hover',
        all: {
          color: 'primary.hover.contrast'
        }
      })), {}, {
        background: {
          color: function color(_ref3) {
            var token = _ref3.token;
            return token('banner.neutral.strong.button.outline.hover.background.color', token('palette.shade.dark.500'));
          }
        }
      }),
      active: _objectSpread(_objectSpread({}, border.tokens({
        target: 'banner.neutral.strong.button.outline.active',
        all: {
          color: 'primary.active.contrast'
        }
      })), {}, {
        background: {
          color: function color(_ref4) {
            var token = _ref4.token;
            return token('banner.neutral.strong.button.outline.active.background.color', token('palette.shade.dark.600'));
          }
        }
      })
    }),
    ghost: _objectSpread(_objectSpread({}, text.tokens({
      target: 'banner.neutral.strong.button.ghost',
      color: function color(_ref5) {
        var token = _ref5.token;
        return token('color.textStyle.body.contrast');
      }
    })), {}, {
      hover: _objectSpread(_objectSpread({}, border.tokens({
        target: 'banner.neutral.strong.button.ghost.hover',
        all: {
          color: function color(_ref6) {
            var token = _ref6.token;
            return token('palette.shade.dark.500');
          }
        }
      })), {}, {
        background: {
          color: function color(_ref7) {
            var token = _ref7.token;
            return token('banner.neutral.strong.button.ghost.hover.background.color', token('palette.shade.dark.500'));
          }
        }
      }),
      active: _objectSpread(_objectSpread({}, border.tokens({
        target: 'banner.neutral.strong.button.ghost.active',
        all: {
          color: function color(_ref8) {
            var token = _ref8.token;
            return token('palette.shade.dark.600');
          }
        }
      })), {}, {
        background: {
          color: function color(_ref9) {
            var token = _ref9.token;
            return token('banner.neutral.strong.button.ghost.active.background.color', token('palette.shade.dark.600'));
          }
        }
      })
    }),
    tint: _objectSpread({}, text.tokens({
      target: 'banner.neutral.strong.button.tint',
      color: function color(_ref10) {
        var token = _ref10.token;
        return token('color.textStyle.body.contrast');
      }
    }))
  }
};
export function NeutralBanner(_ref11) {
  var strong = _ref11.strong,
      props = _objectWithoutProperties(_ref11, _excluded);

  // We need button overrides for the strong neutral banner because
  // it's the only one that doesn't work with the default outline button
  var tokens = useMemo(function () {
    return merge({}, overrides, strong ? strongButtonOverrides : {});
  }, [strong]);
  return /*#__PURE__*/React.createElement(StylesProvider, {
    tokens: tokens
  }, /*#__PURE__*/React.createElement(Banner, _extends({
    strong: strong
  }, props)));
}